var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"tag",style:('color:'+_vm.colors[_vm.type]+';border-color:'+_vm.colors[_vm.type])},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }